import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getDate, getMonth } from '../../functions/dates';
import {
  accordianexpand,
  deliverySelected3,
  dineInSelected3,
  takeawaySelected3,
} from '../../paths/defaultImage';
import {
  DELIVERY_TYPE,
  DINEIN_TYPE,
  LITE_DEL,
  PICKUP_TYPE,
  TAKEAWAY,
} from '../../webStorage/keys/sessionKeys';
import {
  getOrderType,
  getOrderTypeSession,
  getTableId,
  getTableSession,
} from '../../webStorage/manageOrderType';
import { getPickupType, getScheduledPopupVisited } from '../../webStorage/sessionStorage';
import SuspenseWrapper from '../common/suspenseWrapper';
import LazyImage from '../common/lazyLoad';

const OrderTypePopUp = lazy(() =>
  import(/* webpackChunkName:"order-type-popup" */ '../popUp/orderTypePopUp')
);
const ScheduledOrder = lazy(() =>
  import(/* webpackChunkName:"schedule-order-popup" */ '../popUp/ScheduledOrder')
);

const MEDIA_PATH = process.env.REACT_APP_Media_Root_Path_URL;

function OrderType(props) {
  const setting = getOrderTypeSession();
  const { t } = useTranslation();
  const { mall, ot } = useParams();
  const orderTypeFromUrl = +ot - 1;
  const orderTypeText =
    (setting?.orderType == DELIVERY_TYPE && t('delivery_capitalize')) ||
    (setting?.orderType == DINEIN_TYPE && t('dine_in')) ||
    (setting?.orderType == PICKUP_TYPE && t(getPickupType()));
  const orderTypeImg =
    (setting?.orderType == DELIVERY_TYPE && deliverySelected3) ||
    (setting?.orderType == DINEIN_TYPE && dineInSelected3) ||
    (setting?.orderType == PICKUP_TYPE && takeawaySelected3);
  const orderTypeFromSession = getOrderType(false);
  const orderTypeAndTime = useSelector((state) => state.orderTypeOrderTime);
  const openOrderTimeCondition =
    !getScheduledPopupVisited() &&
    ((props.isPreorderAvailable && orderTypeFromUrl == DELIVERY_TYPE) ||
      (props.isPreorderAvailable &&
        orderTypeFromUrl == PICKUP_TYPE &&
        setting?.pickupType != TAKEAWAY)) &&
    orderTypeFromSession != DINEIN_TYPE &&
    !setting?.epoch;
  const [openOrderTime, setOpenOrderTime] = useState(false);
  const tableId = setting?.orderType == DINEIN_TYPE && (getTableSession() || getTableId());

  const openPopUp = () => {
    if (props?.plan === LITE_DEL) {
      return;
    }
    props?.setShowOrderTypePopup(true);
  };
  const closePopUp = () => {
    props?.setShowOrderTypePopup(false);
  };
  const OrderTimeClose = () => {
    setOpenOrderTime(false);
  };

  useEffect(() => {
    if (openOrderTimeCondition) {
      setOpenOrderTime(true);
    }
  }, [orderTypeAndTime.orderType]);

  const getScheduleOrderTime = (orderTime, date, timeRange) => {
    if (props.isRestaurantClosed && orderTime === 'ASAP') {
      return t('pick_schedule_time');
    }
    if (orderTime === 'ASAP') return orderTime;
    let scheduledOrderTime =
      t(getMonth(date)?.slice(0, 3)) +
      ' ' +
      getDate(date) +
      ' (' +
      timeRange?.replace(' ', '') +
      ')';

    return scheduledOrderTime;
  };
  return (
    <>
      <div className='d-flex justify-content-between align-items-center flex-wrap service-option px-20 py-2 gap-1'>
        {/* OrderType - Delivery,DineIn or PickUp */}

        <div
          className=' d-flex  align-items-center justify-content-between order-type-change pointer fw-500 '
          onClick={openPopUp}>
          <LazyImage src={orderTypeImg} alt='order Type' className='order-image ' />
          <div className='fw-700 fs-14 d-flex justify-content-between align-items-center gap-10px '>
            {orderTypeText}
            {props?.plan !== LITE_DEL ? (
              <LazyImage
                className='accordianExpand'
                src={accordianexpand}
                alt='collapse-expand'
                style={{ transform: 'rotate(180deg)' }}
              />
            ) : null}
          </div>
        </div>

        {/* Table Id if Order is Dine In */}

        {tableId && setting?.orderType == DINEIN_TYPE && (
          <div className='font-weight-normal text-bigtag px-3'>
            {t('table')} <span className='mt-1'>{tableId}</span>
          </div>
        )}

        {/* OrderTimings - ASAP and SCHEDULED */}

        {!mall &&
          (setting?.orderType == DELIVERY_TYPE ||
            (setting?.orderType == PICKUP_TYPE && setting?.pickupType !== 'ta')) && (
            <div
              className='d-flex justify-content-between align-items-center pointer  fs-12 '
              onClick={() => setOpenOrderTime(true)}>
              <LazyImage
                src={MEDIA_PATH + '/mweb/unknown4.png'}
                className='order-time-img'
                alt='StopWatchSchedule'
              />
              <span
                className={`${
                  !props.isRestaurantClosed && setting?.orderTime == 'ASAP'
                    ? 'fw-700 fs-14'
                    : 'fw-600 fs-12'
                } ml-2 mr-2`}>
                {t(getScheduleOrderTime(setting?.orderTime, setting?.date, setting?.time))}
              </span>
              <LazyImage
                className='accordianExpand'
                src={accordianexpand}
                alt='collapse-expand'
                style={{ transform: 'rotate(180deg)' }}
              />
            </div>
          )}
      </div>

      {props.showOrderTypePopup && (
        <SuspenseWrapper>
          <OrderTypePopUp
            open={true}
            close={closePopUp}
            openQrScanner={props.openQrScanner}
            showPickupOT={props.showPickupOT}
          />
        </SuspenseWrapper>
      )}

      {openOrderTime &&
        setting?.orderType != 0 &&
        !(setting?.orderType == 2 && setting?.pickupType == 'ta') && (
          <SuspenseWrapper>
            <ScheduledOrder
              close={OrderTimeClose}
              selectedOrderType={getOrderType()}
              isRestaurantClosed={props.isRestaurantClosed}
            />
          </SuspenseWrapper>
        )}
    </>
  );
}
export default OrderType;
